module.exports = __webpack_public_path__ + "static/media/iphone3.6e75bae1.png";